import type { Contact as ContactData } from '../api/schema.js'
import { invitation } from '../data/invitation.js'
import { roleTones, type RoleTone } from '../styles/roleTones.js'
import styles from './Contact.module.css'

export interface ContactProps {
  contact: ContactData
}

interface CardProps {
  eyebrow: string
  name: string
  tel: string
  tone: RoleTone
}

function Card({ eyebrow, name, tel, tone }: CardProps) {
  return (
    <div className={styles.card} style={tone}>
      <div className={styles.cardEyebrow}>{eyebrow}</div>
      <div className={styles.cardName}>{name}</div>
      <div className={styles.actions}>
        <a className={styles.tel} href={`tel:${tel}`}>
          전화
        </a>
        <a className={styles.sms} href={`sms:${tel}`}>
          문자
        </a>
      </div>
    </div>
  )
}

/** 전화번호는 API에서만 온다 — 값이 없으면 그 쪽(혹은 섹션 전체)을 그리지 않는다. */
export function Contact({ contact }: ContactProps) {
  const groomTel = contact.groom?.tel
  const brideTel = contact.bride?.tel
  if (groomTel === undefined && brideTel === undefined) return null

  const both = groomTel !== undefined && brideTel !== undefined

  return (
    <div className={styles.wrap}>
      <div className={styles.divider}>
        <span className={styles.line} />
        <span className={styles.dot} />
        <span className={styles.line} />
      </div>
      <div className={styles.eyebrow}>contact</div>
      <h2 className={styles.title}>축하 인사 전하기</h2>
      <div className={styles.grid} style={{ gridTemplateColumns: both ? '1fr 1px 1fr' : '1fr' }}>
        {groomTel !== undefined && (
          <Card eyebrow="groom" name={`신랑 ${invitation.couple.groom.fullName}`} tel={groomTel} tone={roleTones.groom} />
        )}
        {both && <div className={styles.mid} />}
        {brideTel !== undefined && (
          <Card eyebrow="bride" name={`신부 ${invitation.couple.bride.fullName}`} tel={brideTel} tone={roleTones.bride} />
        )}
      </div>
    </div>
  )
}
